import React from 'react';

const PlantSticker = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 110"
    width="72"
    height="80"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <ellipse cx="50" cy="104" rx="30" ry="5" fill="#2A2D34" opacity="0.08" />

    <path d="M30 70 L70 70 L64 100 L36 100 Z" fill="#C97B5A" />
    <path d="M30 70 L70 70 L67 79 L33 79 Z" fill="#B96A49" />

    <path
      d="M50 72 C50 72 20 60 24 32 C24 32 48 34 50 60 C52 34 76 32 76 32 C80 60 50 72 50 72 Z"
      fill="#1C6E4A"
    />
    <path
      d="M50 72 C50 72 30 64 30 44 C30 44 46 46 50 64 Z"
      fill="#4F9B76"
    />
    <path
      d="M50 60 C50 60 42 34 18 26 C18 26 22 48 44 56 Z"
      fill="#4F9B76"
    />
    <path
      d="M50 60 C50 60 58 34 82 26 C82 26 78 48 56 56 Z"
      fill="#1C6E4A"
    />
  </svg>
);

export default PlantSticker;
